import React, { useEffect } from 'react'
import * as Icons from 'react-feather'
function UserDashboard() {
    useEffect(() => {
       
    }, [])
    return (
        <>
            <div className="row">
                <div className="col-xl-3 col-sm-6 col-12 d-flex">
                    <div className="dash-count">
                        <div className="dash-counts">
                            <h4>0</h4>
                            <h5>Demo 1</h5>
                        </div>
                        <div className="dash-imgs">
                            <Icons.User />
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12 d-flex">
                    <div className="dash-count das1">
                        <div className="dash-counts">
                            <h4>0</h4>
                            <h5>Demo 2</h5>
                        </div>
                        <div className="dash-imgs">
                            <Icons.UserCheck />
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12 d-flex">
                    <div className="dash-count das2">
                        <div className="dash-counts">
                            <h4>0</h4>
                            <h5>Demo 3</h5>
                        </div>
                        <div className="dash-imgs">
                            <img src="/assets/img/icons/file-text-icon-01.svg" className="img-fluid" alt="icon"/>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12 d-flex">
                    <div className="dash-count das3">
                        <div className="dash-counts">
                            <h4>0</h4>
                            <h5>Demo 4</h5>
                        </div>
                        <div className="dash-imgs">
                            <Icons.File />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserDashboard
